import { useSyncExternalStore } from 'react';

const REDUCED_MOTION_QUERY = '(prefers-reduced-motion: reduce)';

const query = (): MediaQueryList | undefined =>
  typeof window === 'undefined' ? undefined : window.matchMedia?.(REDUCED_MOTION_QUERY);

const subscribe = (onChange: () => void): (() => void) => {
  const list = query();
  if (!list) return () => {};

  // Safari below 14 only has the deprecated pair, as does the jsdom stand-in under test.
  if (list.addEventListener) {
    list.addEventListener('change', onChange);
    return () => list.removeEventListener('change', onChange);
  }

  list.addListener(onChange);
  return () => list.removeListener(onChange);
};

const getSnapshot = (): boolean | undefined => query()?.matches;

const getServerSnapshot = (): undefined => undefined;

/**
 * Whether the reader has asked the OS for less motion. `undefined` on the server and while
 * hydrating, so the first client render matches the server HTML. The native sibling reads
 * asynchronously, hence the shape.
 */
const useReducedMotion = (): boolean | undefined =>
  useSyncExternalStore(subscribe, getSnapshot, getServerSnapshot);

export default useReducedMotion;
